import React from 'react';
import { motion } from 'framer-motion';
import { ABOUT_CONTENT } from '../../utils/constants';
import { fadeInUp, slideInLeft, slideInRight } from '../../utils/animations';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="max-w-3xl mx-auto text-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.p
            className="text-brand-500 font-semibold text-sm uppercase tracking-wider mb-3"
            variants={fadeInUp}
          >
            About Us
          </motion.p>
          <motion.h2
            className="text-3xl sm:text-4xl text-neutral-900 leading-tight mb-8"
            style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
            variants={fadeInUp}
          >
            {ABOUT_CONTENT.heading}
          </motion.h2>
          <motion.p
            className="text-neutral-600 text-lg leading-relaxed mb-6"
            style={{ fontFamily: "'Livvic', sans-serif" }}
            variants={slideInLeft}
          >
            {ABOUT_CONTENT.text}
          </motion.p>
          <motion.p
            className="text-neutral-600 text-lg leading-relaxed"
            style={{ fontFamily: "'Livvic', sans-serif" }}
            variants={slideInRight}
          >
            Our approach is consultative — we don't just supply products, we help practices choose the right solutions based on <span className="font-bold text-neutral-800">workflow</span>, <span className="font-bold text-neutral-800">growth goals</span>, and <span className="font-bold text-neutral-800">operational needs</span>.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;